import { mdiMapSearch } from "@mdi/js";
import Icon from "@mdi/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { _serverUrl2 } from "../../config";
import { failed } from "../../Utils/Alerts";
import {
    addSingleFeatureTotempLayerByGeojson,
    addSingleFeatureTotempLayerByXY,
    tempLayer,
    zoomToFeatureByGeojson,
    zoomToFeatureByXY,
} from "../Map/Layers/TempLayer";

export default function AdresComponent() {
    const [visible, setVisible] = useState(false);
    const [selectedForm, setSelectedForm] = useState(0); // True => Adres || False => Ada/Parsel
    const [ilce, setIlce] = useState([]);
    const [mahalle, setMahalle] = useState([]);
    const [csbm, setCsbm] = useState([]);
    const [kapi, setKapi] = useState([]);
    const [adaParsel, setAdaParsel] = useState([]);

    const onChangeIlce = async (id) => {
        // zoomToFeatureByGeojson(ilce.find(d=> d.maks_kimlik_no == id).geojson)
        setMahalle([]);
        setCsbm([]);
        setKapi([]);
        document.getElementById("mah").value = 0;
        document.getElementById("csbm").value = 0;
        document.getElementById("kapi").value = 0;
        let selected = ilce.find((d) => d.maks_kimlik_no == id);
        tempLayer.getSource().clear();
        zoomToFeatureByXY(selected.x, selected.y, 11);
        await axios
            .get(_serverUrl2 + "/main/mah/" + id)
            .then((res) => {
                if (res.data.status) {
                    setMahalle(res.data.rows);
                } else {
                }
            })
            .catch(() => {});
    };

    const onChangeMahalle = async (id) => {
        //zoomToFeatureByGeojson(mahalle.find(d=> d.mah_id == id).geojson)
        setCsbm([]);
        setKapi([]);
        document.getElementById("csbm").value = 0;
        document.getElementById("kapi").value = 0;
        let selected = mahalle.find((d) => d.mah_id == id);
        tempLayer.getSource().clear();
        zoomToFeatureByXY(selected.x, selected.y, 14);
        await axios
            .get(_serverUrl2 + "/main/csbm/" + id)
            .then((res) => {
                if (res.data.status) {
                    setCsbm(res.data.rows);
                } else {
                }
                console.log(setIlce, "hhhıhıu");
            })
            .catch(() => {});
    };

    const onChangeCsbm = async (id) => {
        //zoomToFeatureByGeojson(csbm.find(d=> d.maks_kimlik_no == id).geojson)
        setKapi([]);
        document.getElementById("kapi").value = 0;
        let selected = csbm.find((d) => d.maks_kimlik_no == id);
        console.log(selected.geojson);
        tempLayer.getSource().clear();
        addSingleFeatureTotempLayerByGeojson({ geojson: selected.geojson });
        zoomToFeatureByXY(selected.x, selected.y, 18);
        await axios
            .get(_serverUrl2 + "/main/kapi/" + id)
            .then((res) => {
                if (res.data.status) {
                    setKapi(res.data.rows);
                } else {
                }
            })
            .catch(() => {});
    };

    const onChangeKapi = async (id) => {
        let selected = kapi.find((d) => d.maks_kimlik_no == id);
        tempLayer.getSource().clear();
        zoomToFeatureByXY(selected.x, selected.y, 23);
        addSingleFeatureTotempLayerByXY(selected.x, selected.y);
    };

    const onClickAdaParsel = async () => {
        let postJSON = {
            ilce: document.getElementById("ilce").value,
            ada: document.getElementById("ada").value,
            parsel: document.getElementById("parsel").value,
        };
        await axios
            .post(_serverUrl2 + "/main/adaparsel", postJSON)
            .then((res) => {
                if (res.data.status) {
                    setAdaParsel(res.data.rows);
                }
            });
    };

    const getInfosFromNode = async () => {
        await axios
            .get(_serverUrl2 + "/main/ilce")
            .then((res) => {
                if (res.data.status) {
                    setIlce(res.data.rows);
                } else {
                }
            })
            .catch(() => {});
    };

    const Sorgulama = async () => {
        let json = {
            tip: document.getElementById("maks_sorgu").value,
            kod: document.getElementById("kod").value,
        };
        console.log(json, "json");
        await axios
            .post(_serverUrl2 + `/main/maks/`, json)
            .then((res) => {
                if (res.data.rows.length != 0) {
                    tempLayer.getSource().clear();
                    zoomToFeatureByXY(
                        res.data.rows[0].x,
                        res.data.rows[0].y,
                        20
                    );
                    addSingleFeatureTotempLayerByXY(
                        res.data.rows[0].x,
                        res.data.rows[0].y
                    );
                } else {
                    failed("Bilgi bulunamadı.");
                }
            })
            .catch(() => {});
    };

    useEffect(() => {
        getInfosFromNode();
        return () => {};
    }, []);

    return (
        <button className={visible ? "orangeBtn" : "darkOrangeBtn"}>
            <Icon
                path={mdiMapSearch}
                size={1.5}
                style={{ color: "black", cursor: "pointer" }}
                onClick={() => {
                    setVisible(!visible);
                    tempLayer.getSource().clear();
                }}
            />
            {visible && (
                <div className="row map-overlay-popup adres">
                    <div className="col-6">
                        <button
                            style={{ fontSize: "12px" }}
                            onClick={() => {
                                setSelectedForm(0);
                                tempLayer.getSource().clear();
                            }}
                            className="blueBtn"
                        >
                            Adres
                        </button>
                    </div>
                    <div className="col-6">
                        <button
                            style={{ fontSize: "12px" }}
                            onClick={() => {
                                setSelectedForm(2);
                                tempLayer.getSource().clear();
                            }}
                            className="blueBtn"
                        >
                            Sorgulama
                        </button>
                    </div>
                    <div className="col-4" style={{ display: "none" }}>
                        <button
                            style={{ fontSize: "12px" }}
                            onClick={() => {
                                setSelectedForm(1);
                                tempLayer.getSource().clear();
                            }}
                            className="blueBtn"
                        >
                            Ada/Parsel
                        </button>
                    </div>
                    {selectedForm == 0 ? (
                        <div
                            className="col-sm-12"
                            style={{
                                paddingTop: "10px",
                                paddingBottom: "10px",
                            }}
                        >
                            <select
                                style={{ fontSize: "12px", margin: "1px" }}
                                className="form-control form-select"
                                onChange={(e) => onChangeIlce(e.target.value)}
                            >
                                <option value="0" disabled selected>
                                    İlçe Seçiniz
                                </option>
                                {ilce.map((d, i) => {
                                    return (
                                        <option
                                            key={i}
                                            value={d.maks_kimlik_no}
                                        >
                                            {d.ad}
                                        </option>
                                    );
                                })}
                            </select>
                            <select
                                id="mah"
                                style={{ fontSize: "12px", margin: "1px" }}
                                className="form-control form-select"
                                onChange={(e) =>
                                    onChangeMahalle(e.target.value)
                                }
                            >
                                <option value="0" disabled selected>
                                    Mahalle Seçiniz
                                </option>
                                {mahalle.map((d, i) => {
                                    return (
                                        <option key={i} value={d.mah_id}>
                                            {d.mah_adi}
                                        </option>
                                    );
                                })}
                            </select>
                            <select
                                id="csbm"
                                style={{ fontSize: "12px", margin: "1px" }}
                                className="form-control form-select"
                                onChange={(e) => onChangeCsbm(e.target.value)}
                            >
                                <option value="0" disabled selected>
                                    CSBM Seçiniz
                                </option>
                                {csbm.map((d, i) => {
                                    return (
                                        <option
                                            key={i}
                                            value={d.maks_kimlik_no}
                                        >
                                            {d.yol_ismi + " " + d.yol_tipi}
                                        </option>
                                    );
                                })}
                            </select>
                            <select
                                id="kapi"
                                style={{ fontSize: "12px", margin: "1px" }}
                                className="form-control form-select"
                                onChange={(e) => onChangeKapi(e.target.value)}
                            >
                                <option value="0" disabled selected>
                                    Kapı Seçiniz
                                </option>
                                {kapi.map((d, i) => {
                                    return (
                                        <option
                                            key={i}
                                            value={d.maks_kimlik_no}
                                        >
                                            {d.kapino}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    ) : selectedForm == 1 ? (
                        <>
                            <div
                                className="col-sm-12"
                                style={{ marginTop: "10px" }}
                            >
                                <select
                                    style={{
                                        fontSize: "12px",
                                        marginTop: "1px",
                                    }}
                                    className="form-control form-select"
                                    id="ilce"
                                >
                                    <option value="0" disabled selected>
                                        İlçe Seçiniz
                                    </option>
                                    {ilce.map((d, i) => {
                                        return (
                                            <option
                                                key={i}
                                                value={d.maks_kimlik_no}
                                            >
                                                {d.ad}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <div
                                className="col-sm-4"
                                style={{
                                    marginRight: "0px",
                                    paddingRight: "0px",
                                }}
                            >
                                <input
                                    style={{ fontSize: "12px" }}
                                    className="form-control form-control-sm"
                                    placeholder="Ada"
                                    id="ada"
                                ></input>
                            </div>
                            <div
                                className="col-sm-4"
                                style={{
                                    marginLeft: "0px",
                                    paddingLeft: "0px",
                                }}
                            >
                                <input
                                    style={{ fontSize: "12px" }}
                                    className="form-control form-control-sm"
                                    placeholder="Parsel"
                                    id="parsel"
                                ></input>
                            </div>
                            <div className="col-sm-4">
                                <button
                                    style={{ fontSize: "11px" }}
                                    className="greenBtn"
                                    onClick={() => onClickAdaParsel()}
                                >
                                    Ara
                                </button>
                            </div>
                            <div className="col-sm-12">
                                <hr style={{ margin: "3px" }} />
                            </div>
                            {adaParsel.length != 0 && (
                                <div className="col-sm-12">
                                    <table
                                        className="table table-sm"
                                        style={{ fontSize: "12px" }}
                                    >
                                        <thead>
                                            <tr>
                                                <th>Mahalle</th>
                                                <th>Ada/Parsel</th>
                                                <td></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {adaParsel.map((d, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{d.mah_adi}</td>
                                                        <td>
                                                            {d.ada_no +
                                                                " / " +
                                                                d.parsel_no}
                                                        </td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    fontSize:
                                                                        "10px",
                                                                }}
                                                                onClick={() =>
                                                                    zoomToFeatureByGeojson(
                                                                        d.geojson
                                                                    )
                                                                }
                                                                className="orangeBtn"
                                                            >
                                                                Git
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div
                                className="col-sm-12"
                                style={{ marginTop: "10px" }}
                            >
                                <select
                                    style={{
                                        fontSize: "12px",
                                        marginTop: "1px",
                                    }}
                                    className="form-control form-select"
                                    id="maks_sorgu"
                                >
                                    <option value="0" disabled selected>
                                        Sorgu Tipi
                                    </option>
                                    <option>Kapı</option>
                                    <option>Yapı</option>
                                    <option>Yol Orta Hat</option>
                                    <option>Yol</option>
                                    <option>Direk/Duvar</option>
                                    <option>Diğer Yapı</option>
                                </select>
                            </div>
                            <div
                                className="col-sm-12"
                                style={{ marginTop: "5px" }}
                            >
                                <input
                                    style={{
                                        fontSize: "12px",
                                        marginTop: "1px",
                                    }}
                                    className="form-control form-control-sm"
                                    placeholder="Kod"
                                    id="kod"
                                ></input>
                            </div>
                            <div
                                className="col-sm-12"
                                style={{ marginTop: "10px" }}
                            >
                                <button
                                    className="orangeBtn"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => Sorgulama()}
                                >
                                    Sorgula
                                </button>
                            </div>
                            <div className="col-sm-12">&nbsp;</div>
                        </>
                    )}
                </div>
            )}
        </button>
    );
}
